import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { trackCTA } from "../utils/eventTracker";
import BackgroundImage from "../components/BackgroundImage";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";

export default function Adme() {
  const { t } = useTranslation();
  return (
    <div className="page-wrapper">      
      <BackgroundImage />
      <NavBar />
      <div className="transparency-wrapper">
        <div className="big-title">ADME</div>
        <img
          src="/projects/adme.webp"
          alt="ADME"
          className="project-image"
        />
        <div className="porfolio-project-text-wrapper">
          <p className="section-content-unbounded">
            {t("admeDescriptionShort")}
          </p>

          <p className="section-content-unbounded">
            {t("admeDescriptionLong")}
          </p>
        </div>       
        <div className="cta-button-secondary-wrapper-bottom">
          <Link 
            to="/quote"
            className="cta-button-secondary"
            onClick={() => trackCTA("admePage")}
          >
            {t("ctaBookCall")}
          </Link>
        </div>        
        <Footer /> 
      </div>
    </div>
  );
}
